import { jsonApiClient } from 'shared/model';
import { Category } from '../@types';

const api = jsonApiClient('Category');

export const getCategories = (signal?: AbortSignal) => api.get<Category[]>(undefined, { signal });
